import React from 'react';

import { PersonalizedProductsQuery } from 'src/personalization/data-layer/types';

import EmptyLoadingState from 'src/components/empty-loading-state';
import { Content } from 'src/components/hybrid-carousel/hybrid-carousel.styles';

import { usePersonalizedProductsCarousel } from '../../use-personalized-products-carousel';
import { RecommendationsConciergeCard } from '../recommendations-concierge-card';

import { TabSlider } from './tab-slider';
import { Header } from './header';

type TabbedPersonalizedProductCarouselProps = {
  heading?: string;
  icon?: React.ReactNode;
  personalizedProductsQuery: PersonalizedProductsQuery;
  subheading?: string;
};

export const TabbedPersonalizedProductCarousel = ({
  heading,
  icon,
  personalizedProductsQuery,
  subheading,
}: TabbedPersonalizedProductCarouselProps): JSX.Element | null => {
  const { handleProductClick, handleQuickAddToCart, products, error, loading } = usePersonalizedProductsCarousel({
    personalizedProductsQuery,
  });

  if (error || !products.length) {
    return null;
  }

  return (
    <div data-testid='personalized-products-carousel'>
      <EmptyLoadingState page='personalizedCarousel' isLoading={loading} tabbedHeader>
        <Content>
          <Header heading={heading} icon={icon} subheading={subheading} />
          <TabSlider
            beforeProducts={<RecommendationsConciergeCard />}
            products={products}
            onProductClick={handleProductClick}
            onQuickAddToCart={handleQuickAddToCart}
            isLoading={Boolean(loading)}
          />
        </Content>
      </EmptyLoadingState>
    </div>
  );
};
